module.exports = __webpack_public_path__ + "img/num8.267c81ed.svg";